import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { metaQueries } from '../api/query';
import { MetaData } from '../model/types';
export const useMetadata = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...metaQueries.get(),
      gcTime: Infinity,
      select: _temp8
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
};
function _temp(lv1) {
  return {
    categoryLv1: lv1.category_lv1,
    categoriesLv2: lv1.categories_lv2
  };
}
function _temp2(item) {
  return {
    categoryLv0: item.category_lv0,
    categoriesLv1: item.categories_lv1.map(_temp)
  };
}
function _temp3(item_0) {
  return {
    key: item_0.key,
    image: item_0.image
  };
}
function _temp4(item_1) {
  return {
    key: item_1.key,
    image: item_1.image
  };
}
function _temp5(item_2) {
  return {
    key: item_2.key,
    displayKey: item_2.display_key,
    image: item_2.image,
    maxMainTextLength: item_2.max_main_text_length,
    maxSubTextLength: item_2.max_sub_text_length,
    maxStickers: item_2.max_stickers,
    maxStickerTextLength: 16,
    stickersSupported: item_2.stickers_supported,
    allowedStickerTypes: item_2.allowed_sticker_types
  };
}
function _temp6(item_3) {
  return {
    key: item_3.key,
    displayKey: item_3.display_key
  };
}
function _temp7(item_4) {
  return {
    key: item_4.key,
    ratio: item_4.ratio,
    width: item_4.width,
    height: item_4.height,
    displayKey: item_4.display_key
  };
}
function _temp8(data) {
  return {
    product: {
      classKeys: data.product.class_keys,
      autoColors: data.product.auto_colors,
      categoryMap: data.product.category_map.map(_temp2)
    },
    detail: {
      tones: data.detail.tones,
      templates: data.detail.templates.map(_temp3),
      ageGroups: data.detail.age_groups ?? [],
      genders: data.detail.genders ?? []
    },
    video: {
      ratios: data.video.ratios,
      resolutions: data.video.resolutions,
      lengths: data.video.lengths,
      styles: data.video.styles,
      previews: data.video.previews.map(_temp4)
    },
    banner: {
      templates: data.banner.templates.map(_temp5),
      backgrounds: data.banner.backgrounds.map(_temp6),
      ratios: data.banner.ratios.map(_temp7)
    },
    aiStudio: {
      ratio: data.ai_studio.ratio
    }
  };
}